import { useState, useEffect } from 'react';

import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { useTranslation } from 'react-i18next';

import Headers from './Headers'
import HeadersPrint from './HeadersPrint'

export default function Blocks({ blocks, reportUrl, savedTab, onTabChange, isReadOnly }) {
  const { t } = useTranslation();

  const tabChanged = (t) => {
    setActiveTab(t);
    onTabChange?.(t);
  };

  const [activeTab, setActiveTab] = useState(savedTab || blocks[0]?.uid);
  useEffect(() => {
    if (savedTab) setActiveTab(savedTab);
  }, [savedTab]);

  return (
    <>
      <Tabs
        defaultActiveKey={blocks[0]?.uid}
        id="justify-tab-example"
        className="mb-3"
        justify
        activeKey={activeTab}
        onSelect={(t) => { tabChanged(t); }}
      >
        {blocks.map((block) => {
          return <Tab key={block.uid} eventKey={block.uid} title={block.displayName} className={`${(block.blockType === 10 ? 'mb-5' : '')} pb-4`}>
            {block.blockType === 10 && <Headers headers={block.headers} />}
            {block.blockType === 20 && <HeadersPrint reportUrl={reportUrl} isReadOnly={isReadOnly} isActive={activeTab === block.uid} />}
          </Tab>
        })}

      </Tabs>
    </>
  );
}